/**
 * Extracts the mime type from a file name
 * @param fileName
 * @returns
 */
export const getMimeTypeFromFileName = (fileName: string) => {
  const lowerCaseFileName = fileName?.toLowerCase();
  const extension = lowerCaseFileName?.split('.').pop(); // a.b.c.txt => txt

  switch (extension) {
    case 'jfif':
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'pdf':
      return 'application/pdf';
    case 'mp4':
      return 'video/mp4';
    case 'mov':
      return 'video/quicktime';
    case 'txt':
      return 'text/plain';
    case 'csv':
      return 'text/csv';
    case 'doc':
      return 'application/msword';
    case 'docx':
      return 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    default:
      break;
  }
};
